export default __webpack_public_path__ + "static/media/IntegrationTelegram.db91f114.jpg";